import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ReportItem } from 'src/app/interfaces/reports.interface';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-delete-report-modal',
  templateUrl: './delete-report-modal.component.html',
  styleUrls: ['./delete-report-modal.component.scss']
})
export class DeleteReportModalComponent implements OnInit {
  @Input() report!: ReportItem;
  deleting: boolean = false;

  constructor(
    public modal: NgbActiveModal,
    private reportsService: ReportsService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
  }

  deleteReport() {
    this.deleting = true;
    this.reportsService.deleteReport(this.report.reportId)
      .finally(() => {
        this.deleting = false;
      })
      .then((deleted) => {
        if (deleted) {
          this.modal.close('deleted');
        }
      })
      .catch(() => {
        this.toastr.error('Something went wrong while deleting this report.');
      });
  }

}
